import { create } from 'zustand';

interface TelegramUser {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  languageCode: string;
  photo_url: string;
  isPremium: boolean;
  addedToAttachmentMenu?: boolean;
}

interface TelegramUserState {
  user: TelegramUser | null;
  setUser: (user: TelegramUser) => void;
}

export const useTelegramUserStore = create<TelegramUserState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
})); 